// extracted by mini-css-extract-plugin
export default {"wrap":"queryAndReset_wrap__f37CN","search":"queryAndReset_search__f3xXD","reset":"queryAndReset_reset__3sudA"};